"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.distance = void 0;
var distance = function distance(lat1, lon1, lat2, lon2, unit) {
  var R = 6371e3; // metres

  var φ1 = lat1 * Math.PI / 180; // φ, λ in radians

  var φ2 = lat2 * Math.PI / 180;
  var Δφ = (lat2 - lat1) * Math.PI / 180;
  var Δλ = (lon2 - lon1) * Math.PI / 180;
  var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // in metres

  var km = d / 1000;
  var miles = km * 0.621371;
  return unit === 'mi' ? miles : km;
};
exports.distance = distance;